/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'sarsaparilla';
import isEmpty from 'lodash/isEmpty';
import PublicReview from './PublicReview';
import AIReview from './AIReview';
import { publicReviewPropTypes } from '../model/publicReview';

const propTypes = {
    reviews: PropTypes.arrayOf(publicReviewPropTypes), // This is probably not correct or too strict because it's causes usage in some services to generate errors
    displayLength: PropTypes.number,
    focusPosition: PropTypes.number,
    loading: PropTypes.number,
    flagReview: PropTypes.func,
    voteReview: PropTypes.func,
    openLoginModal: PropTypes.func,
    aiReview: PropTypes.object,
    voteAIReview: PropTypes.func,
};

export default function LocationReviews(props) {
    const {
        loading,
        reviews,
        aiReview,
        displayLength,
        focusPosition,
        flagReview,
        voteReview,
        openLoginModal,
        voteAIReview,
    } = props;
    const targetRef = useRef(null);
    const hasAIReview = !isEmpty(aiReview?.summary);

    useEffect(() => {
        if (focusPosition && targetRef.current) {
            targetRef.current.focus();
        }
    }, [focusPosition]);

    if (!reviews.length) {
        return <div className="location-reviews-wrapper">No reviews to display.</div>;
    }

    return (
        <ul className="location-reviews-wrapper">
            {hasAIReview && (
                <li tabIndex={-1}>
                    <AIReview
                        openLoginModal={openLoginModal}
                        review={aiReview}
                        voteReview={voteAIReview}
                    />
                </li>
            )}

            {reviews.slice(0, displayLength).map((review, index) => (
                <li
                    tabIndex={-1}
                    ref={index === focusPosition ? targetRef : null}
                    key={`review-${review.id || review.reservation_id}`}
                >
                    <PublicReview
                        openLoginModal={openLoginModal}
                        review={review}
                        flagReview={flagReview}
                        voteReview={voteReview}
                    />
                </li>
            ))}
            {loading < displayLength && <Spinner size="xl" />}
        </ul>
    );
}

LocationReviews.propTypes = propTypes;
